import React, { useState, useEffect, useRef } from "react";
import { Button, FormControl, Form } from "react-bootstrap";
import axios from "axios";
import { decryptId } from "../../utils/helpers";
const API_URL = process.env.REACT_APP_API_URL;

function After14Days({ source, sampleId }) {
    const [uptResult, setUptResult] = useState("");
    const [betaHcg, setBetaHcg] = useState("");
    const [gsgc, setGsgc] = useState("");
    const [fetalPole, setFetalPole] = useState("");
    const [cardiacEcho, setCardiacEcho] = useState("");
    const [remark, setRemark] = useState("");

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [followup14daysData, setFollowup14daysData] = useState(null);


    const decodedId = decodeURIComponent(sampleId);
    const id_sample = decryptId(decodedId);
    const alertShown = useRef(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${API_URL}/get_14_days_data/${id_sample}`, {
                headers: { Authorization: `Bearer ${token}` }, params: { followup_type: source }
            })
            .then((res) => {
                const data = res.data.followup14daysData;
                if (!data) return;

                setFollowup14daysData(data);

                setUptResult(data.UPT === "1" ? "Positive" : "Negative");
                setBetaHcg(data.hcg_value ?? "");
                setGsgc(data.gsgc_value ?? "");
                setFetalPole(data.fetal_pole ?? "");
                setCardiacEcho(data.cardiac_echo ?? "");
                setRemark(data.remark ?? "");
            })
            .catch((err) => console.error(err));
    }, [id_sample, source]);




    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!followup14daysData) {
            // alert("Data not loaded yet");

            setErrorMsg("Data not loaded yet");

            setTimeout(() => setErrorMsg(""), 1000);
            return;
        }

        const token = localStorage.getItem("token");

        const payload = {
            sample_id: followup14daysData.sample_id,
            UPT: uptResult === "Positive" ? 1 : 0,
            hcg_value: betaHcg || null,
            gsgc_value: gsgc || null,
            fetal_pole: fetalPole || null,
            cardiac_echo: cardiacEcho || null,
            remark: remark || null,
            followup_type: source || null

        };

        try {
            const res = await axios.put(
                `${API_URL}/add_followup_data/${followup14daysData.followup_id}`,
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            // alert(res.data.message || "Saved successfully");

            setSuccessMsg(
                res.data.message || `Clinical Pregnancy data ${source} saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);
        } catch (err) {
            console.error(err);
            // alert("Error saving follow-up data");
            setErrorMsg("Error saving follow-up data");

            setTimeout(() => setErrorMsg(""), 1000);
        }
    };


    const labelBox = {
        backgroundColor: "#DFF5F1",
        padding: "10px 20px",
        borderRadius: "8px",
        border: "2px solid #4DB6AC",
        fontWeight: "bold",
        fontSize: "18px",
        width: "260px",
        textAlign: "center"
    };

    const inputBox = {
        width: "200px",
        height: "40px",
        border: "2px solid #001A43",
        borderRadius: "6px",
        fontSize: "18px",
        paddingLeft: "10px"
    };

    const bigInput = {
        width: "300px",
        height: "60px",
        border: "2px solid #001A43",
        borderRadius: "6px",
        fontSize: "18px",
        padding: "10px"
    };

    return (
        <div>
            <h6 style={{ textAlign: "left" }}>
                After 14 Days

            </h6>
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            {/* <h6 style={{ textAlign: "left" }}>
                After 14 Days{" "}
                <span title="sample Code"
                    style={{
                        marginLeft: "8px",
                        padding: "4px 10px",
                        backgroundColor: "#DFF5F1",
                        color: "#001A43",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "600",
                        letterSpacing: "0.5px"
                    }}
                >
                    {followup14daysData?.sample_code}
                </span>
            </h6> */}


            <Form onSubmit={handleSubmit}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "40px"
                    }}
                >
                    <div
                        style={{
                            flex: 1,
                            padding: "25px",
                            borderRadius: "12px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "30px"
                        }}
                    >
                        <div style={labelBox}>UPT</div>

                        <div style={{ display: "flex", gap: "30px", fontSize: "18px" }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <input
                                    type="radio"
                                    name="upt"
                                    value="Positive"
                                    checked={uptResult === "Positive"}
                                    onChange={() => setUptResult("Positive")}
                                />
                                Positive
                            </label>

                            <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <input
                                    type="radio"
                                    name="upt"
                                    value="Negative"
                                    checked={uptResult === "Negative"}
                                    onChange={() => setUptResult("Negative")}
                                />
                                Negative
                            </label>
                        </div>

                        <div style={labelBox}>Beta HCG value</div>
                        <FormControl
                            type="text"
                            style={inputBox}
                            value={betaHcg}
                            onChange={(e) => setBetaHcg(e.target.value)}
                        />
                    </div>

                    <div
                        style={{
                            flex: 1.2,
                            padding: "25px",
                            borderRadius: "12px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "25px"
                        }}
                    >
                        <div style={labelBox}>Pregnancy confirmation by Sonography</div>

                        <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
                            <div style={labelBox}>G SGC</div>
                            <FormControl
                                as="textarea"
                                style={bigInput}
                                value={gsgc}
                                onChange={(e) => setGsgc(e.target.value)}
                            />
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
                            <div style={labelBox}>Fetal Pole</div>
                            <FormControl
                                as="textarea"
                                style={bigInput}
                                value={fetalPole}
                                onChange={(e) => setFetalPole(e.target.value)}
                            />
                        </div>

                        <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
                            <div style={labelBox}>Cardiac Echo</div>
                            <FormControl
                                as="textarea"
                                style={bigInput}
                                value={cardiacEcho}
                                onChange={(e) => setCardiacEcho(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="mb-3">
                    <FormControl
                        as="textarea" value={remark}
                        rows={2} onChange={(e) => setRemark(e.target.value)}
                        placeholder="Enter remarks here"
                        style={{ width: "1000px", marginTop: "30px" }}
                    />
                </div>

                <div className="d-flex justify-content-center mt-4">
                    <Button
                        type="submit" disabled={!followup14daysData}
                        variant="primary"
                        className="px-4 mb-4"
                    >
                        Save
                    </Button>
                </div>
            </Form >
        </div>

    );
}

export default After14Days;
